import { Box, Typography, Divider, Stack } from '@mui/material'

import { Patient } from '@/core/models/patient.model'

import { MergeFieldItem } from './MergeFieldItem'
import { MergePatientsFormSelection } from '../model/useMergePatientsForm'

type FieldGroup = {
  title: string
  fields: Array<{ key: string; label: string }>
}

type MergeFieldGroupProps = {
  fieldGroups: FieldGroup[]
  primaryPatient: Patient
  secondaryPatient: Patient
}

export function MergeFieldGroup({ fieldGroups, primaryPatient, secondaryPatient }: MergeFieldGroupProps) {
  return (
    <>
      {fieldGroups.map((group) => (
        <Box key={group.title}>
          <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {group.title}
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Stack spacing={2}>
            {group.fields.map(({ key, label }) => (
              <MergeFieldItem key={key} fieldKey={key} label={label} primaryPatient={primaryPatient} secondaryPatient={secondaryPatient} />
            ))}
          </Stack>
        </Box>
      ))}
    </>
  )
}
